<template>
  <DetailInfo v-if="showBackdrop" />
  <div
    v-else
    class="relative bg-white text-whitebase"
    :style="`background:${
      isCustom
        ? state.customClass === 'ape'
          ? '#040718FF'
          : '#12032EFF'
        : '#121416'
    }`"
  >
    <div v-if="!loading && !showBackdrop" class="w-full h-full">
      <div v-if="isCustom" class="absolute inset-0 z-0" style="height: 250px">
        <img
          v-if="isDesktop && state.customClass === 'aavegotchi'"
          :style="`width: 100vw; height:341px;margin-top:-72px; `"
          class="object-contain opacity-70"
          src="@/assets/bgs/aavegotchi-main.avif"
          alt=""
        />
        <img
          v-if="isDesktop && state.customClass === 'ape'"
          :style="`width: 100vw; height:341px;margin-top:-72px; `"
          class="object-contain opacity-70"
          src="@/assets/bgs/ape-main.avif"
          alt=""
        />
        <img
          v-if="!isDesktop && state.customClass === 'aavegotchi'"
          :style="`width: 100vw; height:341px;margin-top:-72px; `"
          class="object-contain opacity-70"
          src="@/assets/bgs/aavegotchi-mobile.avif"
          alt=""
        />
        <img
          v-if="!isDesktop && state.customClass === 'ape'"
          :style="`width: 100vw; height:341px;margin-top:-72px; `"
          class="object-contain opacity-70"
          src="@/assets/bgs/ape-mobile.avif"
          alt=""
        />
      </div>
      <div class="flex flex-col relative mx-auto max-w-80 px-4 md:px-10">
        <div class="mt-6 md:mt-12">
          <div
            class="flex h-max md:h-18 items-center pass-bg rounded-lg mb-6"
            v-if="!state.isInited"
          >
            <div class="p-3 md:p-0 md:ml-24">
              The DAO is newly listed! It will take a little bit time to process
              and fetch the data. Please note the profile is not complete yet.
              ❤️
            </div>
          </div>

          <div class="flex justify-between items-center">
            <div class="relative">
              <UiImg
                :src="
                  state.info.logo || require('@/assets/icons/nftnologo.avif')
                "
                class="w-14 md:w-16 h-14 md:h-16 overflow-hidden rounded-full"
              ></UiImg>
              <router-link :to="verifyUrl">
                <div
                  v-if="state.info.createType != 1"
                  class="
                    rounded-sm
                    font-bold
                    h-5
                    px-1
                    text-whitebase text-xs
                    absolute
                    bottom-0
                    left-1/2
                    transform
                    scale-75
                    -translate-x-1/2
                    translate-y-1
                    whitespace-nowrap
                    transition-opacity
                    hover:opacity-90
                    cursor-pointer
                    flex
                    items-center
                    justify-center
                    font-10
                  "
                  style="background: #ff5585"
                >
                  Claim&Share
                </div>
              </router-link>
            </div>

            <div>
              <div v-if="!isDesktop">
                <ThreeDotMenu :daoInfo="state.info" />
              </div>
              <div v-if="isDesktop" class="flex space-x-2 justify-end">
                <div
                  class="
                    h-6
                    px-4
                    items-center
                    font-bold
                    mb-2
                    text-xs
                    hidden
                    md:flex
                    text-mb-red
                  "
                  style="
                    border: 1px solid #ff5585b3;
                    border-radius: 8px;
                    width: fit-content;
                    background: #ff55851a;
                  "
                >
                  {{ state.info.daoCategory == 1 ? 'DeFi DAO' : 'NFT DAO' }}
                </div>
                <div
                  class="
                    h-6
                    px-4
                    items-center
                    font-bold
                    mb-2
                    text-xs
                    hidden
                    md:flex
                  "
                  style="
                    border: 1px solid #5e6873;
                    border-radius: 8px;
                    width: fit-content;
                  "
                >
                  {{ state.info.daoType }}
                </div>
              </div>

              <div class="flex justify-end">
                <LinkCell :daoInfo="state.info"></LinkCell>
              </div>
            </div>
          </div>

          <div class="flex items-center mt-2">
            <span class="mr-2 font-bold"> {{ state.info.name }} </span>

            <tippy content="Twitter is authenticated" :arrow="false">
              <img
                v-if="state.info.isTwitterOauth"
                class="w-5 h-5"
                src="@/assets/icons/tw_ok.avif"
                alt=""
              />
            </tippy>
          </div>
          <div v-if="!isDesktop" class="flex justify-between">
            <div class="flex space-x-2 mt-2">
              <div
                class="h-6 px-4 items-center font-bold text-xs flex text-mb-red"
                style="
                  border: 1px solid #ff5585b3;
                  border-radius: 8px;
                  width: fit-content;
                  background: #ff55851a;
                "
              >
                {{ state.info.daoCategory == 1 ? 'DeFi DAO' : 'NFT DAO' }}
              </div>
              <div
                class="h-6 px-4 items-center font-bold text-xs flex"
                style="
                  border: 1px solid #5e6873;
                  border-radius: 8px;
                  width: fit-content;
                "
              >
                {{ state.info.daoType }}
              </div>
            </div>
            <img
              v-if="isCustom && state.customClass === 'aavegotchi'"
              @click="$router.replace({ name: 'Report' })"
              class="w-10 h-10 self-end cursor-pointer"
              src="@/assets/icons/report-aavegotchi-icon.avif"
              alt="report icon"
            />
            <img
              v-if="isCustom && state.customClass === 'ape'"
              @click="$router.replace({ name: 'Report' })"
              class="w-10 h-10 self-end cursor-pointer"
              src="@/assets/icons/report-ape-icon.avif"
              alt="report icon"
            />
          </div>
          <div class="flex flex-wrap mt-2 space-x-3">
            <div
              class="h-5 px-2 flex items-center text-xs rounded"
              style="background: rgba(255, 255, 255, 0.1)"
              v-for="(item, i) in state.info.daoTag"
              :key="i"
            >
              #{{ item }}
            </div>
          </div>
          <div class="relative flex justify-between">
            <SeeMoreText
              class="mb-4 md:mb-6 mt-4"
              :text="state.info.intro"
              style="color: #ffffffb3"
              :maxLength="80"
            >
            </SeeMoreText>
            <div>
              <div
                style="width: 232px"
                class="rounded-lg"
                v-if="groupedEventsForWeek?.length > 0"
                :style="`background:${
                  determineEventType(
                    groupedEventsForWeek[selectedEvent].eventGroup,
                  ) === 'daoProposal'
                    ? '#12D3A21A'
                    : determineEventType(
                        groupedEventsForWeek[selectedEvent].eventGroup,
                      ) === 'meeting'
                    ? '#F725851A'
                    : '#4895EF1A'
                }`"
              >
                <div
                  class="
                    p-2
                    flex
                    justify-between
                    items-center
                    font-bold
                    text-xs
                  "
                >
                  Upcoming Calendar
                  <span
                    class="
                      iconfont
                      icon-right
                      font-normal
                      text-xs
                      cursor-pointer
                    "
                    @click="$router.replace({ name: 'DaoPage Calendar' })"
                  ></span>
                </div>
                <div
                  v-for="{ eventGroup, eventType } in groupedEventsForWeek"
                  :key="eventType"
                >
                  <div
                    class="flex items-center justify-between text-xs p-2"
                    :class="{
                      ['text-whitebase bg-' + eventType]: treasuryCurrency,
                    }"
                  >
                    <div>
                      {{
                        eventType == 'meeting'
                          ? 'Meeting'
                          : eventType == 'daoProposal'
                          ? 'Proposal Starts'
                          : 'Twitter Space'
                      }}
                    </div>
                    <div class="text-white-040 w-max">
                      {{ formatTimeStamp(eventGroup.startTime * 1000) }}
                    </div>
                  </div>
                  <div
                    @click="handleRedirect(eventGroup.link)"
                    class="p-2 text-xs text-white-070 cursor-pointer flex"
                  >
                    <!-- Display event details here -->
                    <div class="line-clamp-2 hover:underline">
                      {{ eventGroup.title }}
                    </div>
                  </div>
                </div>
              </div>
              <img
                v-if="
                  isDesktop && isCustom && state.customClass === 'aavegotchi'
                "
                @click="$router.replace({ name: 'Report' })"
                class="w-10 h-10 self-end cursor-pointer"
                src="@/assets/icons/report-aavegotchi-icon.avif"
                alt="report icon"
              />
              <img
                v-if="isDesktop && isCustom && state.customClass === 'ape'"
                @click="$router.replace({ name: 'Report' })"
                class="w-10 h-10 self-end cursor-pointer"
                src="@/assets/icons/report-ape-icon.avif"
                alt="report icon"
              />
            </div>
          </div>
        </div>

        <div
          class="
            flex flex-wrap
            justify-between
            pt-2.5
            pb-0
            md:pb-4
            bg-white
            sticky
            z-40
          "
          :style="`background:${
            isCustom
              ? state.customClass === 'ape'
                ? '#040718FF'
                : '#12032EFF'
              : '#121416'
          }`"
          style="border-bottom: 1px solid #ffffff1a; top: 71.5px"
          ref="scrollToper"
        >
          <div class="flex flex-wrap space-x-0 md:space-x-6 mb-4 md:mb-0">
            <div
              v-for="(info, i) in baseInfo"
              :key="i"
              class="w-28 md:w-auto h-11 md:h-auto"
            >
              <div v-if="info.value === '--'">{{ info.value }}</div>
              <CountUp
                v-else
                :value="info.value"
                :isEth="state.byUnit.value === 'ETH'"
                class="text-base font-bold text-whitebase"
                :isMonetary="info.name === 'Treasury'"
                :isLocale="Number.isInteger(info.value)"
                :toFixed="Number.isInteger(info.value) ? 0 : 1"
              />

              <div class="text-gray-level text-xs">
                {{ info.name }}

                <tippy :content="info.tip" :arrow="false">
                  <i
                    v-if="info.tip"
                    class="iconfont icon-tishi text-xs text-whitebase"
                  ></i>
                </tippy>
              </div>
            </div>
          </div>

          <div class="flex items-center space-x-2">
            <div class="flex">
              <div
                class="font-bold flex items-center pl-2 rounded-lg h-8"
                style="border: 1px solid #2a2e33"
              >
                <UiCheckBox
                  :isCustom="isCustom"
                  v-model="state.includeOwnAssets"
                >
                  <span class="text-xs">
                    Native Token Ratio ({{ NATIVE_TOKEN_RATIO }}%)
                  </span>
                </UiCheckBox>
              </div>
            </div>
            <UiDropdown
              class="w-32 z-50"
              size="sm"
              v-model="state.byKey"
              :isBetween="false"
              textCapital
              :options="[
                {
                  label: 'By history',
                  value: 'ByHistory',
                },
                {
                  label: 'By floor',
                  value: 'ByFloor',
                },
              ]"
            ></UiDropdown>
          </div>
          <div v-if="!isDesktop" class="mt-4 pb-2 overflow-hidden">
            <div class="hideScroll overflow-x-auto relative">
              <div class="flex w-max" style="color: #ffffffb3">
                <div
                  class="cursor-pointer px-2 text-sm py-1.5 relative"
                  :class="{
                    'flex items-center ':
                      !isCustom || (isCustom && tab.name !== 'Treasury'),

                    'pl-0 w-full flex flex-col justify-center items-start':
                      isCustom && tab.name === 'Treasury',

                    '  text-whitebase  font-bold': tab.checkPath.includes(
                      $route.name,
                    ),

                    'bg-inputActive':
                      !isCustom && tab.checkPath.includes($route.name),
                    ['bg-' + state.customClass]:
                      isCustom &&
                      tab.name !== 'Treasury' &&
                      tab.checkPath.includes($route.name),
                    ' text-white-070':
                      !tab.checkPath.includes($route.name) && !tab.disabled,
                    ' cursor-not-allowed text-white-030': tab.disabled,
                    ' hover:bg-white-003 hover:text-whitebase':
                      !tab.disabled && !tab.checkPath.includes($route.name),
                  }"
                  v-for="(tab, i) in tabs"
                  :key="i"
                  @click="
                    () => {
                      if (tab.name === 'Treasury' && isCustom) {
                      } else {
                        jumpTab(tab);
                      }
                    }
                  "
                >
                  <div
                    @click="
                      () => {
                        if (isCustom && tab.name === 'Treasury') {
                          state.expandTab = !state.expandTab;
                        }
                      }
                    "
                    class="flex justify-between w-full items-center"
                  >
                    <div
                      class="whitespace-nowrap"
                      :class="{
                        'pl-4 mr-1': isCustom && tab.name === 'Treasury',
                      }"
                    >
                      {{ tab.name }}
                    </div>
                    <i
                      v-if="tab.name === 'Treasury' && isCustom"
                      class="iconfont icon-right transition-all mr-4 w-4 h-4"
                      :class="{
                        'transform rotate-90': state.expandTab,
                      }"
                    ></i>
                  </div>
                </div>

                <!-- <div class="mr-4 pt-4" style="border-top: 1px solid #ffffff1a">
                <UiDropdown
                  v-model="state.byUnit"
                  :options="UnitOptions"
                  noBorder
                ></UiDropdown>
              </div> -->
              </div>
            </div>
          </div>
          <div
            v-if="isCustom && !isDesktop && state.expandTab"
            class="flex"
            :class="{
              'border-b border-white-010  ': state.expandTab,
            }"
          >
            <div
              class="flex justify-center items-center cursor-pointer text-sm"
              style="width: 171px; height: 32px"
              :class="{
                'text-whitebase font-bold': subTab.checkPath.includes(
                  $route.name,
                ),
                'bg-inputActive':
                  !isCustom && subTab.checkPath.includes($route.name),
                ['bg-' + state.customClass]:
                  isCustom && subTab.checkPath.includes($route.name),
                'text-white-070':
                  !subTab.checkPath.includes($route.name) && !subTab.disabled,
                'cursor-not-allowed text-white-030': subTab.disabled,
              }"
              v-for="(subTab, j) in tabs.find((x) => x.name === 'Treasury')
                .subtabs"
              :key="j"
              @click="
                () => {
                  jumpTab(subTab);
                }
              "
            >
              <div>
                {{ subTab.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex">
          <div
            v-if="isDesktop"
            class="w-44 sticky h-80 pt-6"
            style="
              color: #ffffffb3;
              top: 145px;
              height: calc(100vh - 145px);
              box-shadow: 8px 0px 8px 0px rgba(87, 87, 87, 0.15);
            "
          >
            <div
              class="w-43 min-h-10 rounded-lg cursor-pointer"
              :class="{
                'flex items-center pl-4':
                  !isCustom || (isCustom && tab.name !== 'Treasury'),

                'pl-0 w-full flex flex-col justify-center items-start':
                  isCustom && tab.name === 'Treasury',

                '  text-whitebase  font-bold': tab.checkPath.includes(
                  $route.name,
                ),
                'bg-white-005':
                  !isCustom && tab.checkPath.includes($route.name),
                ['bg-' + state.customClass]:
                  isCustom &&
                  tab.name !== 'Treasury' &&
                  tab.checkPath.includes($route.name),
                ' text-white-070':
                  !tab.checkPath.includes($route.name) && !tab.disabled,
                ' cursor-not-allowed text-white-030': tab.disabled,
                ' hover:bg-white-003 hover:text-whitebase':
                  !tab.disabled && !tab.checkPath.includes($route.name),
              }"
              v-for="(tab, i) in tabs"
              :key="i"
              @click="
                () => {
                  if (tab.name === 'Treasury' && isCustom) {
                  } else {
                    jumpTab(tab);
                  }
                }
              "
            >
              <div
                @click="
                  () => {
                    if (isCustom && tab.name === 'Treasury') {
                      state.expandTab = !state.expandTab;
                    }
                  }
                "
                class="flex justify-between w-full min-h-10 items-center"
              >
                <div :class="{ 'pl-4': isCustom && tab.name === 'Treasury' }">
                  {{ tab.name }}
                </div>
                <i
                  v-if="tab.name === 'Treasury' && isCustom"
                  class="iconfont icon-right transition-all mr-4"
                  :class="{
                    'transform rotate-90': state.expandTab,
                  }"
                ></i>
                <img
                  v-if="
                    tab.checkPath.includes($route.name) &&
                    tab.name !== 'Treasury' &&
                    isCustom &&
                    state.customClass === 'aavegotchi'
                  "
                  class="h-6 w-4 mr-4"
                  src="@/assets/logo/aavegotchi-icon.avif"
                  alt="aavegotchi logo"
                />
                <img
                  v-if="
                    tab.checkPath.includes($route.name) &&
                    tab.name !== 'Treasury' &&
                    isCustom &&
                    state.customClass === 'ape'
                  "
                  class="h-4 w-4 mr-4"
                  src="@/assets/logo/ape-icon.png"
                  alt="ape logo"
                />
              </div>
              <div
                v-if="isCustom && tab.name === 'Treasury' && state.expandTab"
                :class="{
                  'border-b border-white-010 pb-4 mb-2': state.expandTab,
                }"
              >
                <div
                  class="
                    w-43
                    h-10
                    pl-6
                    flex
                    justify-between
                    items-center
                    rounded-lg
                    cursor-pointer
                    text-sm
                  "
                  :class="{
                    'text-whitebase font-bold': subTab.checkPath.includes(
                      $route.name,
                    ),
                    'bg-white-005':
                      !isCustom && subTab.checkPath.includes($route.name),
                    ['bg-' + state.customClass]:
                      isCustom && subTab.checkPath.includes($route.name),
                    'text-white-070':
                      !subTab.checkPath.includes($route.name) &&
                      !subTab.disabled,
                    'cursor-not-allowed text-white-030': subTab.disabled,
                  }"
                  v-for="(subTab, j) in tab.subtabs"
                  :key="j"
                  @click="
                    () => {
                      jumpTab(subTab);
                    }
                  "
                >
                  <div>
                    {{ subTab.name }}
                  </div>
                  <img
                    v-if="
                      subTab.checkPath.includes($route.name) &&
                      isCustom &&
                      state.customClass === 'aavegotchi'
                    "
                    class="h-6 w-4 mr-4"
                    src="@/assets/logo/aavegotchi-icon.avif"
                    alt="aavegotchi logo"
                  />
                  <img
                    v-if="
                      subTab.checkPath.includes($route.name) &&
                      isCustom &&
                      state.customClass === 'ape'
                    "
                    class="h-4 w-4 mr-4"
                    src="@/assets/logo/ape-icon.png"
                    alt="ape logo"
                  />
                </div>
              </div>
            </div>

            <div class="mr-4 pt-4" style="border-top: 1px solid #ffffff1a">
              <UiDropdown
                v-model="state.byUnit"
                :options="UnitOptions"
                noBorder
              ></UiDropdown>
            </div>
          </div>
          <div class="flex-1 min-w-0 pt-6 pl-0 md:pl-6">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="w-full h-full flex justify-center items-center">
      <Spin size="3em"></Spin>
    </div>
  </div>
</template>

<script setup>
import {
  getDaoInfo,
  getEvents,
  getMemberGraph,
  hasMember,
  twVerify,
} from '@/api/dao';
import UiCheckBox from '@/components/CheckBox.vue';
import CountUp from '@/components/CountUp.vue';
import LinkCell from '@/components/LinkCell.vue';
import SeeMoreText from '@/components/SeeMoreText.vue';
import Spin from '@/components/Spin.vue';
import ThreeDotMenu from '@/components/ThreeDotMenu.vue';
import UiDropdown from '@/components/UiDropdown.vue';
import UiImg from '@/components/UiImg.vue';
import { DashboardDisplayType } from '@/constants';
import { useDesktop, useReqByBool } from '@/hooks';
import { formatVal, getTwitterVerifyUrl, numeralNum } from '@/utils';
import { withThrottling } from '@/utils/with';
import {
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  provide,
  reactive,
  ref,
  watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import DetailInfo from './components/DetailInfo.vue';

const scrollToper = ref(null);
const $router = useRouter();
const $route = useRoute();
const isDesktop = useDesktop();

const store = useStore();
const treasuryCurrency = computed(() => store.state.treasuryCurrency);
const showBackdrop = computed(() => store.state.showBackdrop);

// const handleEventUpdate = (event) => {
//   console.log(selectedEvent.value, event, selectedEvent.value == event);
//   const t = determineEventType(event);
//   console.log(t);
//   selectedEvent.value = event;
// };
function formatTimeStamp(time) {
  // Create a Date object from the Unix timestamp
  const date = new Date(time);

  // Extract the components
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() returns 0-11
  const day = date.getDate();
  let hour = date.getHours();
  const minutes = date.getMinutes();

  // Convert to 12-hour format and set AM/PM
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  hour = hour ? hour : 12; // the hour '0' should be '12'

  // Format each component to ensure two digits
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedHour = hour < 10 ? `0${hour}` : hour;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Construct the formatted string
  return `(${year}-${formattedMonth}-${formattedDay} ${formattedHour}:${formattedMinutes} ${ampm})`;
}

const handleRedirect = (url) => {
  window.open(url);
};

const tabs = computed(() => {
  const res = [
    {
      name: 'Overview',
      key: 'DaoPage',
      pathName: 'DaoPage Overview',
      checkPath: ['DaoPage Overview'],
    },
  ];
  const xres = [];

  if (state.info.hasPass) {
    res.push({
      name: 'NFT PASS',
      pathName: 'DaoPage NftPass',
      disabled: !state.info.hasPass,
      checkPath: ['DaoPage NftPass'],
    });
  } else {
    xres.push({
      name: 'NFT PASS',
      pathName: 'DaoPage NftPass',
      disabled: true,
      checkPath: [],
    });
  }

  if (state.info.dashboardIsOpen) {
    res.push({
      name: 'Treasury',
      pathName: [
        DashboardDisplayType.ONLY_NFT_COLLECTION,
        DashboardDisplayType.BOTH_AND_NFT_COLLECTION_FIRST,
      ].includes(state.info.displayType)
        ? 'NFT VAULT'
        : 'FT VAULT',
      disabled: !state.info.dashboardIsOpen,
      checkPath: [
        'FT VAULT',
        'NFT VAULT LIST STATE',
        'FT VAULT STATE',
        'NFT VAULT',
        'NFT VAULT LIST',
        'NFT VAULT DETAIL',
        'Report',
      ],
      subtabs: [
        {
          name: 'Treasury',
          pathName: [
            DashboardDisplayType.ONLY_NFT_COLLECTION,
            DashboardDisplayType.BOTH_AND_NFT_COLLECTION_FIRST,
          ].includes(state.info.displayType)
            ? 'NFT VAULT'
            : 'FT VAULT',
          disabled: !state.info.dashboardIsOpen,
          checkPath: [
            'FT VAULT',
            'NFT VAULT',
            'NFT VAULT LIST',
            'NFT VAULT DETAIL',
            'NFT VAULT LIST STATE',
            'FT VAULT STATE',
          ],
        },
        {
          name: 'Treasury Report',
          pathName: 'Report',
          checkPath: ['Report'],
        },
      ],
    });
  } else {
    xres.push({
      name: 'Treasury',
      pathName: 'DaoPage Treasury',
      disabled: !state.info.dashboardIsOpen,
      checkPath: [],
      subtabs: [
        {
          name: 'Treasury',
          pathName: 'DaoPage Treasury',
          disabled: !state.info.dashboardIsOpen,
          checkPath: [
            'FT VAULT',
            'NFT VAULT',
            'NFT VAULT LIST',
            'NFT VAULT DETAIL',
            'NFT VAULT LIST STATE',
            'FT VAULT STATE',
          ],
        },
        {
          name: 'Treasury Report',
          pathName: 'Report',
          checkPath: ['Report'],
        },
      ],
    });
  }

  if (state.info.hasGovernance) {
    res.push({
      name: 'Governance',
      pathName: 'DaoPage Governance',
      disabled: false,
      checkPath: ['DaoPage Governance'],
    });
  } else {
    xres.push({
      name: 'Governance',
      pathName: '',
      disabled: true,
      checkPath: [],
    });
  }

  if (state.isMember) {
    res.push({
      name: 'Members',
      pathName: 'DaoPage Member',
      disabled: false,
      checkPath: ['DaoPage Member'],
    });
  } else {
    xres.push({
      name: 'Members',
      pathName: '',
      disabled: true,
      checkPath: [''],
    });
  }
  // if (state.isMember) {
  res.push({
    name: 'Calendar',
    pathName: 'DaoPage Calendar',
    disabled: false,
    checkPath: ['DaoPage Calendar'],
  });
  // } else {
  //   res.push({
  //     name: 'Events',
  //     pathName: '',
  //     disabled: true,
  //     checkPath: [''],
  //   });
  // }
  const x = res.concat(xres);

  // x.push({
  //   name: 'Voting',
  //   key: 'Voting',
  //   path: 'Voting',
  //   disabled: true,
  //   checkPath: [],
  // });
  return x;
});
const state = reactive({
  includeOwnAssets: true,
  byKey: { label: 'By history', value: 'ByHistory' },
  byUnit: { label: 'USDT', value: 'USDT' },
  info: {},
  isInited: false,
  limitTop: 0,
  expandTab: false,
  isProposalDetailsOpen: false,
  multiSigData: [],
  results: [],
  customClass: '',
});

// const isTip = computed(() => {
//   return state.info.createTime
//     ? dayjs(dayjs(Date.now()).diff(state.info.createTime), 'hour', true) <
//         21600000
//     : true;
// });

const isFloor = computed(() => state.byKey.value == 'ByFloor');
// aavegotchi id, ape dao coin id
const isCustom = computed(() => {
  if (state.info.id === 959) {
    return true;
  } else if (state.info.id === 1212) {
    return true;
  } else {
    return false;
  }
});
const UnitOptions = computed(() =>
  (state.info.currencies || []).map((x) => ({ label: x, value: x })),
);

const NATIVE_TOKEN_RATIO = computed(() => {
  const value = isFloor.value
    ? state.info.selfProportionByFloor
    : state.info.selfProportionByHistory;
  return (value * 100).toFixed(2);
});

const TREASURY = computed(() => {
  if (isFloor.value) {
    return state.byUnit.value == 'USDT'
      ? state.info.totalValueUsdFloorPrice
      : state.byUnit.value == 'ETH'
      ? state.info.totalValueFloorPrice
      : 0;
  } else {
    return state.byUnit.value == 'USDT'
      ? state.info.totalValueUsd
      : state.byUnit.value == 'ETH'
      ? state.info.totalValue
      : 0;
  }
});

const verifyUrl = computed(() => {
  let key = '';
  if (state.info.twitter) {
    const x = state.info.twitter.split('/');
    key = x[x.length - 1];
  } else {
    key = null;
  }

  return getTwitterVerifyUrl(state.info.name, key, state.info.daoPath);
});
const groupedEventsForWeek = computed(() => {
  const startDate = new Date();

  console.log(startDate);
  const endDate = new Date();
  endDate.setDate(startDate.getDate() + 7);
  console.log(events.value);
  // Filter events within the date range
  const filteredEvents = events.value.filter((event) => {
    const eventDate = new Date(event.startTime * 1000);
    return eventDate >= startDate && eventDate < endDate;
  });
  console.log(filteredEvents);
  const mostRecentEvent = filteredEvents.reduce((acc, event) => {
    return !acc || event.startTime < acc.startTime ? event : acc;
  }, null);
  console.log(mostRecentEvent);
  if (mostRecentEvent) {
    // Determine the type of the most recent event
    const eventType = determineEventType(mostRecentEvent);

    // Return the most recent event and its type
    return [{ eventGroup: mostRecentEvent, eventType }];
  }

  return null; // Return null if no events found
});

function determineEventType(event) {
  console.log(event);
  if (state.events['twitterSpace']?.includes(event)) return 'twitterSpace';
  if (state.events['daoProposal']?.includes(event)) return 'daoProposal';
  if (state.events['googleMeeting']?.includes(event)) return 'meeting';
  return null;
}
const baseInfo = computed(() => [
  {
    name: 'Treasury',
    value: TREASURY.value
      ? formatVal(TREASURY.value, { bit: 2, omit: true })
      : '--',
  },
  {
    name: 'Token holders',
    value: state.info.tokenHolders ? state.info.tokenHolders : '--',
    tip: "Token Holders refers to the sum of the number of DAO's NFT and FT governance token holders",
  },
  {
    name: 'Proposal',
    value: state.info.proposals ? numeralNum(state.info.proposals) : '--',
  },
  {
    name: 'Voters',
    value: state.info.voters ? state.info.voters : '--',
  },
  {
    name: 'Twitter Followers',
    value: state.info.twitterFans ? numeralNum(state.info.twitterFans) : '--',
  },
  {
    name: 'Discord members',
    value: state.info.discordMember
      ? numeralNum(state.info.discordMember)
      : '--',
  },
]);
const events = ref([]); // New ref to store events
const selectedEvent = ref(0); // New ref to store events
const { loadData, loading } = useReqByBool(async () => {
  const info = await getDaoInfo($route.params.name);
  let startDate = new Date();
  console.log(startDate);

  startDate.setHours(0, 0, 0, 0);
  console.log(startDate);
  let endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 7);
  let startTime = startDate.getTime() / 1000;
  let endTime = endDate.getTime() / 1000;
  try {
    const response = await getEvents($route.params.name, startTime, endTime);
    console.log(response);
    if (response) {
      state.events = response;
      if (response['twitterSpace']?.length > 0)
        events.value = [...events.value, ...response['twitterSpace']];
      if (response['daoProposal']?.length > 0)
        events.value = [...events.value, ...response['daoProposal']];
      if (response['googleMeeting']?.length > 0)
        events.value = [...events.value, ...response['googleMeeting']];
    }
  } catch (e) {
    console.log(e);
  }
  state.info = info;
  const isMember = await hasMember(info.id);
  state.isMember = isMember;

  const res = await getMemberGraph(info.id);
  state.multiSigData = res;

  const unit = state.info.currencies[0];
  state.byUnit = { label: unit, value: unit };
  state.isInited = info.isInited;
});
watch(
  () => $route.name,
  (val) => {
    if (tabs.value[1].checkPath.includes($route.name)) {
      state.expandTab = true;
    }
  },
);
watch(
  () => isCustom.value,
  () => {
    if (state.info.id === 959) {
      state.customClass = 'aavegotchi';
    } else if (state.info.id === 1212) {
      state.customClass = 'ape';
    } else {
      state.customClass = '';
    }
  },
);
watch(
  () => treasuryCurrency.value,
  () => {
    state.byUnit = {
      label: treasuryCurrency.value,
      value: treasuryCurrency.value,
    };
  },
);
watch(() => $route.params.name, loadData);
watch(
  () => state.includeOwnAssets,
  async () => {
    const info = await getDaoInfo($route.params.name, state.includeOwnAssets);
    state.info = {
      ...state.info,
      ...info,
    };
  },
);

provide('daoPageInfo', {
  vueState: state,
  isFloor,
  TREASURY,

  isCustom,
});

const jumpTab = (item) => {
  if (item.disabled) {
    return;
  }

  if (window.pageYOffset > state.limitTop) window.scrollTo(0, state.limitTop);

  $router.replace({ name: item.pathName });
};

const doGrant = withThrottling(async (name) => {
  const link = await twVerify(
    state.info.name,
    `${window.location.origin}/twoauth/${name}`,
  );
  window.location.href = link;
});

onMounted(async () => {
  await loadData();
  if (tabs.value[1].checkPath.includes($route.name)) {
    state.expandTab = true;
  }
  nextTick(() => {
    const { top, height } = scrollToper.value.getBoundingClientRect();
    state.limitTop = top - height;
  });

  store.commit('setShowTreasuryCurrency', true);
});
onUnmounted(() => {
  store.commit('toggleBackdrop', false);
  store.commit('setShowTreasuryCurrency', false);
});
</script>

<style>
.disable-hover :hover,
.disable-hover :focus {
  pointer-events: none;
  cursor: default;
}
</style>
